import { render, staticRenderFns } from "./ArchivedEmployees.vue?vue&type=template&id=f2e0c5f6"
import script from "./ArchivedEmployees.vue?vue&type=script&lang=js"
export * from "./ArchivedEmployees.vue?vue&type=script&lang=js"
import style0 from "./ArchivedEmployees.vue?vue&type=style&index=0&id=f2e0c5f6&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2e0c5f6')) {
      api.createRecord('f2e0c5f6', component.options)
    } else {
      api.reload('f2e0c5f6', component.options)
    }
    module.hot.accept("./ArchivedEmployees.vue?vue&type=template&id=f2e0c5f6", function () {
      api.rerender('f2e0c5f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/views/rh/gestion/employee/ArchivedEmployees.vue"
export default component.exports